<template>
  <div id="app">
    <vue-progress-bar/>
    <navbar/>
    <router-view/>
  </div>
</template>

<script>
import navbar from '@/components/navbar'
export default {
    name: 'app',
    components: {
        navbar
    }
}
</script>

<style>
html,

body {
    height: 100%;
}

.btn-to-top {
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue